import React from "react";
import { Button } from "components/button";
import { CubeSheetCard } from "components/CubeSheetCard";
import "./CubeSheet.scss"
import { FormGroup, Validators, FormBuilder, FormControl } from "react-reactive-form";

export interface CubeSheetProps {
    onClick?(): void;
    formControl?: FormControl;
}

export interface CubeSheetState {

}

class CubeSheet extends React.Component<CubeSheetProps, CubeSheetState> {
    constructor(props: CubeSheetProps) {
        super(props);
        this.state = {};
    }
    getSignature() {
        //debugger;
        // var isAffirm=(localStorage.getItem("isAffirm") || "0");
        // if(this.props.formControl){
        //     if(isAffirm=="1"){
        //         this.props.formControl.setValue("1")
        //     }else{
        //         this.props.formControl.setValue("0")
        //     }
        // }

        if (this.props.onClick) {
            this.props.onClick()

        }
    }
    render() {
        return (
            <div className="todo-container">
                <div style={{ height: "60vh", overflowY: "scroll", width: "100%" }}>
                    <CubeSheetCard />
                </div>
                <div style={{width:"100%"}}>
                    <Button
                        text={"Continue"}
                        onClick={() => this.getSignature()}
                    />
                </div>
            </div>
        );
    }
}

export default CubeSheet;